module.exports = __webpack_public_path__ + "bj.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/bj.svg
// module id = 706
// module chunks = 0